import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { BookingContextService } from '../../../modules_v2/booking/services/booking-context.service';
import { NotificationService } from '../../../modules_v2/shared/services/notification.service';
import { LoadingDialogService } from '../../../shared/ui/loading/loading-dialog.service';


@Component({
    selector: 'app-booking-subscription-activation-dialog',
    templateUrl: './booking-subscription-activation-dialog.component.html',
    styleUrls: ['./booking-subscription-activation-dialog.component.css'],
    standalone: false
})
export class BookingSubscriptionActivationDialogComponent implements OnInit {
  trialEndDate: Date = new Date(2026, 11, 31);
  monthlyPrice: number = 0;
  canStartTrial = false;
  trialUsed = false;
  isChecking = true;
  isStartingTrial = false;

  constructor(
    public dialogRef: MatDialogRef<BookingSubscriptionActivationDialogComponent>,
    private bookingContextService: BookingContextService,
    private notification: NotificationService,
    private loading: LoadingDialogService,
    @Inject(MAT_DIALOG_DATA) public data?: any
  ) {
    if (data && data.monthlyPrice !== undefined) {
      this.monthlyPrice = data.monthlyPrice;
    }
  }

  ngOnInit(): void {
    this.bookingContextService.getBookingMerchantStatus().subscribe({
      next: response => {
        const value = response && response.isSuccess ? response.value : null;

        this.trialUsed = !!(value && value.trialUsed);

        if (value && value.canStartTrial) {
          this.canStartTrial = true;

          if (value.trialEndDate) {
            this.trialEndDate = new Date(value.trialEndDate);
          }
        }

        this.isChecking = false;
      },
      error: () => this.isChecking = false
    });
  }

  onConfirm(): void {
    if (this.canStartTrial) {
      this.startTrial();
      return;
    }

    this.dialogRef.close(true);
  }

  onCancel(): void {
    this.dialogRef.close(false);
  }

  private startTrial(): void {
    this.isStartingTrial = true;
    this.dialogRef.disableClose = true;

    this.loading.run('Activando tu prueba de Reservas PRO…', this.bookingContextService.startBookingTrial())
      .then(response => {
        if (response && response.isSuccess) {
          this.notification.ok('Prueba de Reservas PRO activada');
          this.dialogRef.close('trial');
          return;
        }

        this.failTrial();
      })
      .catch(() => this.failTrial());
  }

  private failTrial(): void {
    this.isStartingTrial = false;
    this.dialogRef.disableClose = false;
    this.notification.error('No se ha podido activar la prueba. Inténtalo de nuevo.');
  }

  getFormattedTrialEndDate(): string {
    return this.trialEndDate.toLocaleDateString('es-ES', {
      day: 'numeric',
      month: 'long',
      year: 'numeric'
    });
  }
}
